import * as PIXI from 'pixi.js';
import { dashLine } from '@/lib/common';

export default class PixiRRLne {
  private width: number;
  private height: number;

  private t: PIXI.Graphics;
  private t1: PIXI.Graphics;
  private t2: PIXI.Graphics;
  private s: PIXI.Graphics;

  private container: PIXI.Container;

  constructor(width: number, height: number) {
    this.width = width;
    this.height = height;

    this.container = new PIXI.Container();

    this.t = new PIXI.Graphics();
    this.t.lineStyle(1, 0x5dFFFF);
    dashLine(this.t, 0, 0, 0, height, 3, 1);

    this.t1 = new PIXI.Graphics();
    this.t1.lineStyle(1, 0x5dFFFF);
    dashLine(this.t1, 0, 0, 0, height, 3, 1);

    this.t2 = new PIXI.Graphics();
    this.t2.lineStyle(1, 0x5dFFFF);
    dashLine(this.t2, 0, 0, 0, height, 3, 1);

    this.s = new PIXI.Graphics();
    this.s.lineStyle(1, 0x5dFFFF);
    dashLine(this.s, 0, 0, width, 0, 3, 1);

    this.container.addChild(this.t, this.t1, this.t2, this.s);
  }

  public get() {
    return this.container;
  }

  public set(t: number, t1: number, t2: number, s: number) {
    this.t.position.x = t;
    this.t1.position.x = t1;
    this.t2.position.x = t2;
    this.s.position.y = s;
  }
}
